(function () {
  if (window.__ringBuilderCartCleanupLoaded) return;
  window.__ringBuilderCartCleanupLoaded = true;

  const getProperty = (item, key) => {
    if (!item.properties) return '';
    return item.properties[key] || '';
  };

  const cleanupOrphanDiamonds = async () => {
    try {
      const cart = await fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      }).then((response) => response.json());

      const settingIds = new Set(
        cart.items
          .filter((item) => getProperty(item, '_Ring Builder Item') === 'Setting')
          .map((item) => getProperty(item, '_Ring Builder ID'))
          .filter(Boolean)
      );

      const orphanDiamonds = cart.items.filter((item) => {
        const itemType = getProperty(item, '_Ring Builder Item');
        const builderId = getProperty(item, '_Ring Builder ID');
        return itemType === 'Diamond' && builderId && !settingIds.has(builderId);
      });

      if (!orphanDiamonds.length) return;

      const updates = {};
      orphanDiamonds.forEach((item) => {
        updates[item.key] = 0;
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      window.location.reload();
    } catch (error) {
      return;
    }
  };

  cleanupOrphanDiamonds();
})();